import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from "@angular/forms";

//import { KioskService } from "../kiosk.service";
import { LocalStorageService } from "@dodo/local-storage/trycatch-local-storage.service";
import { QualificationError } from "app/_core/_models/qualification.models";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { Auth0Service } from "app/_core/services/auth0.service";
import { DodoService } from "app/_core/services/models/dodo-service.model";

@Component({
    selector: "bobo-thankyou",
    templateUrl: "./bobo-thankyou.component.html",
    styleUrls: ["./bobo-thankyou.component.scss"],
    standalone: false
})
export class BoboThankyouComponent implements OnInit {
	// _selectedService = <DodoService>{};

	// _kiosk: Auth0User;
	// _services = <DodoService[]>[
	// 	{
	// 		id: "internet",
	// 		name: "Internet",
	// 		image: "assets/img/icons/product-broadband.svg",
	// 		homeRoute: "qualification/internet"
	// 	}
	// ];
	// _error: QualificationError;
	// _actions = [
	// 	{
	// 		name: "Logout",
	// 		id: "logout"
	// 	}
	// ];
	// constructor(
	// 	private __router: Router,
	// 	private __kioskService: KioskService,
	// 	private __localStore: LocalStorageService,
	// 	private __auth0Service: Auth0Service
	// ) {}

	ngOnInit() {
		// this._kiosk = this.__kioskService.getKiosk();
		// if (this._kiosk && !this._kiosk.isEmailVerified) {
		// 	this._error = <QualificationError>{
		// 		title: `Email address not verified`,
		// 		msg: `
		// 		Please verify your email address.<br/>Verification link has been sent to:<br/> ${this._kiosk.email}
		// 		<br/><br/>For help call 13DODO.
		// 			<p class="order-no">Error Code: DSF_DEALER_01</p>
		// 			`,
		// 		errorCode: "DSF_DEALER_01",
		// 		errorDescription:
		// 			"Dodo Sales Funnel: Kiosk: Email address not verified",
		// 		finePrint: "",
		// 		enableRequestCallback: true,
		// 		category: "sq_failed_500",
		// 		image: "/assets/img/dodo_sheepish.png",
		// 		tealiumErrorCode: "DSF_KIOSK_01",
		// 		tealiumErrorDescription:
		// 			"Dodo Sales Funnel: Kiosk: Email address not verified"
		// 	};
		// 	this.__kioskService.deleteKiosk();
		// }

	// 	if (this._kiosk.service) {
	// 		this._selectedService =
	// 			this._services.filter(s => s.id === this._kiosk.service.id)[0] ||
	// 			<DodoService>{};
	// 	}
	// 	this.__localStore.deleteFromLocalStorage("kioskEnergyView");
	// }

	// _contineuToSqCheck() {
	// 	this.__kioskService.storeKioskSelectedService(this._selectedService);
	// 	this.__router.navigate([this._selectedService.homeRoute]);
	// }

	// _tileClicked(service): void {
	// 	this._selectedService = service;
	// 	service.id === "MSATS/MIRN" ?
	// 		this.__localStore.setInLocalStorage("kioskEnergyView", true)
	// 		:
	// 		this.__localStore.deleteFromLocalStorage("kioskEnergyView");
	// }

	// _actionClicked(actionId: string) {
	// 	switch (actionId) {
	// 		case "logout":
	// 			this.__auth0Service.logoutKiosk();
	// 			break;
	// 		default:
	// 			break;
	// 	}
	}
}
